import React from "react";

interface ChevronRightIconProps {
  className?: string;
  color?: string;
}

const ChevronRightIcon: React.FC<ChevronRightIconProps> = ({
  className = "w-4 h-4",
  color = "#1C1B1F",
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
  >
    <mask
      id="mask0_2604_1225"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2604_1225)">
      <path
        d="M9.88709 8.00016L4.86526 2.97833C4.73282 2.84589 4.66832 2.68822 4.67176 2.50533C4.67521 2.32244 4.74315 2.16472 4.8756 2.03216C5.00804 1.89972 5.16571 1.8335 5.3486 1.8335C5.53148 1.8335 5.68921 1.89972 5.82176 2.03216L10.9256 7.14633C11.046 7.26689 11.1353 7.40194 11.1934 7.5515C11.2517 7.70105 11.2808 7.85061 11.2808 8.00016C11.2808 8.14972 11.2517 8.29927 11.1934 8.44883C11.1353 8.59838 11.046 8.73344 10.9256 8.854L5.81143 13.9682C5.67898 14.1006 5.52304 14.1651 5.3436 14.1617C5.16404 14.1582 5.00804 14.0903 4.8756 13.9578C4.74315 13.8254 4.67693 13.6677 4.67693 13.4848C4.67693 13.3019 4.74315 13.1442 4.8756 13.0117L9.88709 8.00016Z"
        fill={color}
      />
    </g>
  </svg>
);

export default ChevronRightIcon;
